import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormCustomFieldRadio', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/custom_fields/radio/radio.html'),
        controller: 'RadioCustomFieldFormController',
        controllerAs: 'RadioCustomFieldFormCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            field: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/custom_fields/radio/radio.component.ts